
import { mapState } from "vuex";
import CurrencyConverter from "../common/currency-converter.vue";

export default {
  components: { CurrencyConverter },

  computed: {
    ...mapState("order", ["cart"]),

    getTotalItems() {
      return this.cart.items.reduce((total, item) => total + item.quantity, 0);
    },
    getTotalAmount() {
      return this.cart?.prices?.total_amount_to_pay;
    }
  },

  methods: {
    navigateToCart() {
      this.$router.push({ path: `cart` });
    }
  }
};
